import React from "react";
import Box from "@mui/material/Box";
import { DefaultLabel } from "@assets/label";
import { OutlinedInputDefault } from "@assets/TextField";
import { priceResult, adminValueCheck, nulltoZero } from "@assets/utils/check";

const ImpressionsCpm = ({
  cpm_limit,
  is_cpm,
  cpm_current,
  value,
  view_count,
  click_count,
  onChange,
  onCurrentChange,
}) => {
  const viewCount = nulltoZero(view_count);
  const clickCount = nulltoZero(click_count);
  const clickPer = (nulltoZero(clickCount / viewCount) * 100).toFixed(2) + "%";

  return (
    <>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="보장 노출 수" />
        <OutlinedInputDefault
          value={cpm_limit ? priceResult(cpm_limit) : 0}
          disabled={
            !adminValueCheck(value.user.ADMIN) || is_cpm === "N" ? true : false
          }
          inputType="text"
          onChange={(e) => onChange(e)}
          name={"cpm_limit"}
          krName={"보장 노출 수"}
        />
      </Box>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="현재 노출 수" />
        <OutlinedInputDefault
          value={cpm_current ? priceResult(cpm_current) : "-"}
          disabled={true}
          inputType="text"
          // onChange={(e) => onCurrentChange(e)}
          name={"cpm_current"}
          krName={"현재 노출 수"}
        />
      </Box>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="클릭수" />
        <OutlinedInputDefault
          value={clickCount}
          disabled={true}
          inputType="text"
          name={"click_count"}
          krName={"클릭수"}
        />
      </Box>
      <Box sx={{ mb: 3, width: "49%" }}>
        <DefaultLabel name="클릭률" />
        <OutlinedInputDefault
          value={clickPer}
          disabled={true}
          inputType="text"
          name={"click_per"}
          krName={"클릭률"}
        />
      </Box>
    </>
  );
};

export default ImpressionsCpm;
